const CURRENT = 'maxmarket.customer-call';
const CACHE = CURRENT + '.cache';
export function normalizeCallPhone(value) {
  const match = /^(?:\+7|7|8)?(\d{10})$/.exec((value || '').replace(/[\s().\-\u2010-\u2015]/g, ''));
  return match ? '+7' + match[1] : null;
}
function valid(value) {
  return value && /^[a-f\d-]{36}$/i.test(value.challengeId) && /^[\w-]{43}$/.test(value.secret) && /^\+7\d{10}$/.test(value.phone) &&
    Date.parse(value.expiresAt) > Date.now() && value.status !== 'expired' &&
    (!value.callPhone || /^\+7\d{10}$/.test(value.callPhone));
}
function read(key, fallback) { try { return JSON.parse(sessionStorage.getItem(key)) || fallback; } catch { return fallback; } }
function cache() {
  const records = Object.values(read(CACHE, {})), current = read(CURRENT, null);
  if (current) records.push(current);
  return Object.fromEntries(records.filter(valid).slice(-5).map(value => [value.phone, value]));
}
export function currentCall() { const value = read(CURRENT, null); return valid(value) ? value : null; }
export function callForPhone(phone) { return cache()[phone] || null; }
export function saveCall(value) {
  const records = cache(); records[value.phone] = value;
  sessionStorage.setItem(CACHE, JSON.stringify(records));
  sessionStorage.setItem(CURRENT, JSON.stringify(value));
}
export function forgetCall(value) {
  if (!value) return;
  const records = cache();
  if (records[value.phone]?.challengeId === value.challengeId) delete records[value.phone];
  sessionStorage.setItem(CACHE, JSON.stringify(records));
  if (read(CURRENT, null)?.challengeId === value.challengeId) sessionStorage.removeItem(CURRENT);
}
export function newCall(phone) {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const secret = btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return { challengeId: crypto.randomUUID(), secret, phone, status: 'starting', startedAt: Date.now(), expiresAt: new Date(Date.now() + 300000).toISOString() };
}
